import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6c60c3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary" }
const _hoisted_2 = { class: "ticket-name" }
const _hoisted_3 = { class: "ticket-details" }
const _hoisted_4 = { class: "ticket-price" }

import { useBookingStore } from "@/store/bookingStore";



export default /*#__PURE__*/_defineComponent({
  __name: 'TicketSummary',
  props: {
  title: {
    type: String,
    default: "",
  },
  ticketId: {
    type: String,
    default: "",
  },
  ageGroup: {
    type: String,
    default: "",
  },
  comfort: {
    type: String,
    default: "",
  },
  price: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const bookingStore = useBookingStore();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.ageGroup) + ", " + _toDisplayString(__props.comfort), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(__props.price) + " kr", 1)
  ]))
}
}

})